<!--
  @USE AS:
  import CopyData from '@/components/base/CopyData'

  components: { CopyData }

  <CopyData
    :value="value"
  />
-->

<template>
  <div
    class="copy-data"
    :class="{
      'is-clicked': clicked
    }"
    @click="copyBankNumber(value)"
  >
    <InputWrap
      ref="input"
      :readOnly="true"
      v-model="value"
    />

    <span
      v-if="subDisplay"
      v-html="subDisplay"
    >
    </span>

    <span v-html="tempDisplay"></span>

    <div
      v-if="clicked"
      class="copy-data-copied"
    >
      <span>
        copied <br />
        <hr />
        <span v-html="tempDisplay"></span>
      </span>
    </div>
  </div>
</template>

<script>
import InputWrap from '@/components/base/InputWrap.vue'
export default {
  name: 'CopyData',

  components: {
    InputWrap
  },

  props: {
    value: {
      type: [String, Number],
      default: null
    },

    display: {
      type: String,
      default: null
    },

    subDisplay: {
      type: String,
      default: null
    }
  },

  data () {
    return {
      clicked: false
    }
  },

  computed: {
    tempDisplay () {
      return this.display || this.value
    }
  },

  methods: {
    copyBankNumber (val) {
      const data = this.$refs.input.$el.children[0]
      data.select()
      data.setSelectionRange(0, 99999)
      document.execCommand('copy')

      this.clicked = true

      setTimeout(() => {
        this.clicked = false
      }, 600)
    }
  }
}
</script>
